import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [
  { path: '/login', component: () => import('@/views/login/index'), hidden: true },
  { path: '/adminlogin', component: () => import('@/views/login/adminindex'), hidden: true},
  { path: '/admingwsj', component: () => import('@/views/login/admingwsj'), hidden: true},
  { path: '/gwsj', component: () => import('@/views/employment/index'), hidden: true},
  { path: '/admingwsb', component: () => import('@/views/login/admingwsb'), hidden: true},
  { path: '/examine/pdfExamine', component: () => import('@/views/examine/pdfview'), hidden: true },
  { path: '/interview/interviewShow', component: () => import('@/views/interview/show'), hidden: true },
  { path: '/404', component: () => import('@/views/404'), hidden: true },
  {
    path: '',
    component: Layout,
    redirect: '/home',
    children: [{
      path: 'home',
      name: 'home',
      component: () => import('@/views/home/index'),
      meta: { title: '首页/招聘计划', icon: 'home' }
    }]
  }
]

export const asyncRouterMap = [
  {
    path: '/plan',
    component: Layout,
    redirect: '/plan',
    name: 'plan',
    meta: { title: '招聘计划', icon: 'plan' },
    children: [
      {
        path: 'plan',
        name: 'plan',
        component: () => import('@/views/plan/index'),
        meta: { title: '招聘计划管理', icon: 'plan' },
        hidden: true
      },
      {
        path: 'addPlan',
        name: 'addPlan',
        component: () => import('@/views/plan/add'),
        meta: { title: '添加招聘计划' },
        hidden: true
      },
      {
        path: 'updatePlan',
        name: 'updatePlan',
        component: () => import('@/views/plan/update'),
        meta: { title: '编辑招聘计划' },
        hidden: true
      }
    ]
  }, {
    path: '/seting',
    component: Layout,
    redirect: '/seting',
    name: 'seting',
    meta: { title: '系统设置', icon: 'cms' },
    children: [
      {
        path: 'setinfo',
        name: 'setinfo',
        component: () => import('@/views/seting/index'),
        meta: { title: '系统设置', icon: 'seting' }
      },
      {
        path: 'flowseting',
        name: 'flowseting',
        component: () => import('@/views/seting/flow/index'),
        meta: { title: '流程管理', icon: 'flow' }
      },
      {
        path: 'flowset',
        name: 'flowset',
        component: () => import('@/views/seting/flow/set'),
        meta: { title: '流程设置', icon: 'flow' },
        hidden: true
      }
    ]
  }, {
    path: '/atta',
    component: Layout,
    redirect: '/atta',
    name: 'atta',
    meta: { title: '管理报考材料', icon: 'atta' },
    children: [
      {
        path: 'atta',
        name: 'atta',
        component: () => import('@/views/atta/index'),
        meta: { title: '报考材料', icon: 'atta' }
      },
      {
        path: 'addAtta',
        name: 'addAtta',
        component: () => import('@/views/atta/add'),
        meta: { title: '添加材料' },
        hidden: true
      },
      {
        path: 'updateAtta',
        name: 'updateAtta',
        component: () => import('@/views/atta/update'),
        meta: { title: '编辑材料' },
        hidden: true
      },
      {
        path: 'qualificationCode',
        name: 'qualificationCode',
        component: () => import('@/views/atta/qualificationCode'),
        meta: { title: '资格证书配置', icon: 'qualification' }
      },
    ]
  },  {
    path: '/hireatta',
    component: Layout,
    redirect: '/hireatta',
    name: 'hireatta',
    meta: { title: '管理考核材料', icon: 'hireatta' },
    children: [
      {
        path: 'hireatta',
        name: 'hireatta',
        component: () => import('@/views/hireatta/index'),
        meta: { title: '材料管理', icon: 'hire' },
        hidden: true
      },
      {
        path: 'addhireAtta',
        name: 'addhireAtta',
        component: () => import('@/views/hireatta/add'),
        meta: { title: '添加材料' },
        hidden: true
      },
      {
        path: 'updatehireAtta',
        name: 'updatehireAtta',
        component: () => import('@/views/hireatta/update'),
        meta: { title: '编辑材料' },
        hidden: true
      }
    ]
  },{
    path: '/appset',
    component: Layout,
    redirect: '/appset',
    name: 'appset',
    meta: { title: '管理简历模版', icon: 'appset' },
    children: [
      {
        path: 'appset',
        name: 'appset',
        component: () => import('@/views/appset/index'),
        meta: { title: '管理简历模版', icon: 'atta' },
        hidden: true
      },
      {
        path: 'updateAppset',
        name: 'updateAppset',
        component: () => import('@/views/appset/update'),
        meta: { title: '编辑简历模版' },
        hidden: true
      },
      {
        path: 'viewAppset',
        name: 'viewAppset',
        component: () => import('@/views/appset/view'),
        meta: { title: '预览简历模版' },
        hidden: true
      }
    ]
  }, {
    path: '/notice',
    component: Layout,
    redirect: '/notice',
    name: 'notice',
    meta: { title: '招聘变更通知', icon: 'notice' },
    children: [
      {
        path: 'notice',
        name: 'notice',
        component: () => import('@/views/notice/index'),
        meta: { title: '通知公告', icon: 'atta' },
        hidden: true
      },
      {
        path: 'addNotice',
        name: 'addNotice',
        component: () => import('@/views/notice/add'),
        meta: { title: '添加通知公告' },
        hidden: true
      },
      {
        path: 'updateNotice',
        name: 'updateNotice',
        component: () => import('@/views/notice/update'),
        meta: { title: '编辑通知公告' },
        hidden: true
      }
    ]
  },
  {
    path: '/examineimport',
    component: Layout,
    redirect: '/examineimport',
    name: 'examineimport',
    meta: { title: '导入终审结果', icon: 'examineimport' },
    children: [
      {
        path: 'examineimport',
        name: 'examineimport',
        component: () => import('@/views/examine/import'),
        meta: { title: '导入终审结果', icon: 'hire' },
        hidden: true
      }
    ]
  },{
    path: '/room',
    component: Layout,
    redirect: '/room',
    name: 'room',
    meta: { title: '考场设置', icon: 'cms' },
    children: [
      {
        path: 'room',
        name: 'room',
        component: () => import('@/views/room/index'),
        meta: { title: '考场设置', icon: 'cms' },
        hidden: true
      }
    ]
  }, {
    path: '/applicants',
    component: Layout,
    redirect: '/applicants',
    name: 'applicants',
    meta: { title: '简历管理', icon: 'applicants' },
    children: [
      {
        path: 'appindex',
        name: 'appindex',
        component: () => import('@/views/applicants/index'),
        meta: { title: '简历列表', icon: 'appindex' },
        hidden: true
      },
      {
        path: 'viewApp',
        name: 'viewApp',
        component: () => import('@/views/applicants/view'),
        meta: { title: '简历查看' },
        hidden: true,
        display: true
      }
    ]
  },{
    path: '/payinfo',
    component: Layout,
    redirect: '/payinfo',
    name: 'payinfo',
    meta: { title: '缴费结果', icon: 'applicants' },
    children: [
      {
        path: 'into',
        name: 'into',
        component: () => import('@/views/examine/payinfo'),
        meta: { title: '导入缴费结果', icon: 'appindex' },
        hidden: true
      }
    ]
  },{
    path: '/examine',
    component: Layout,
    redirect: '/examine',
    name: 'examine',
    meta: { title: '资格审查', icon: 'examine' },
    children: [
      {
        path: 'examine',
        name: 'examine',
        component: () => import('@/views/examine/index'),
        meta: { title: '资格审查', icon: 'examine' },
        hidden: true
      },
      {
        path: 'updateExamine',
        name: 'updateExamine',
        component: () => import('@/views/examine/update'),
        meta: { title: '最终审查' },
        hidden: true
      },
      {
        path: 'rehearExamine',
        name: 'rehearExamine',
        component: () => import('@/views/examine/rehear'),
        meta: { title: '专项审查' },
        hidden: true
      },
      {
        path: 'firstExamine',
        name: 'firstExamine',
        component: () => import('@/views/examine/first'),
        meta: { title: '初步审查' },
        hidden: true
      },
      {
        path: 'viewExamine',
        name: 'viewExamine',
        component: () => import('@/views/examine/view'),
        meta: { title: '简历查看' },
        hidden: true,
        display: true
      },
      {
        path: 'pdfExamine',
        name: 'pdfExamine',
        component: () => import('@/views/examine/pdfview'),
        meta: { title: '简历打印' },
        hidden: true,
        display: true
      }
    ]
  }, {
    path: '/admission',
    component: Layout,
    redirect: '/admission',
    name: 'admission',
    meta: { title: '准考证', icon: 'admission' },
    children: [
      {
        path: 'admission',
        name: 'admission',
        component: () => import('@/views/admission/index'),
        meta: { title: '准考证', icon: 'atta' },
        hidden: true
      },
      {
        path: 'importAdmission',
        name: 'importAdmission',
        component: () => import('@/views/admission/components/importAdmission'),
        meta: { title: '导入准考证' },
        hidden: true
      },
      {
        path: 'updateAdmission',
        name: 'updateAdmission',
        component: () => import('@/views/admission/components/updateAdmission'),
        meta: { title: '编辑准考证' },
        hidden: true
      }
      ,
      {
        path: 'viewAdmission',
        name: 'viewAdmission',
        component: () => import('@/views/admission/components/viewAdmission'),
        meta: { title: '查看准考证' },
        hidden: true
      }
    ]
  }, {
    path: '/result',
    component: Layout,
    redirect: '/result',
    name: 'result',
    meta: { title: '成绩管理', icon: 'result' },
    children: [
      {
        path: 'result',
        name: 'result',
        component: () => import('@/views/result/index'),
        meta: { title: '成绩管理', icon: 'atta' },
        hidden: true
      },
      {
        path: 'importResult',
        name: 'importResult',
        component: () => import('@/views/result/components/importResult'),
        meta: { title: '导入成绩' },
        hidden: true
      },
      {
        path: 'selResult',
        name: 'selResult',
        component: () => import('@/views/result/components/selResult'),
        meta: { title: '查看|发布成绩' },
        hidden: true
      },
      {
        path: 'updateResult',
        name: 'updateResult',
        component: () => import('@/views/result/update'),
        meta: { title: '编辑成绩' },
        hidden: true
      }
    ]
  }, {
    path: '/inhire',
    component: Layout,
    redirect: '/inhire',
    name: 'inhire',
    meta: { title: '拟录用', icon: 'inhire' },
    children: [
      {
        path: 'inhireindex',
        name: 'inhireindex',
        component: () => import('@/views/inhire/index'),
        meta: { title: '拟录用列表' },
        hidden: true
      }
    ]
  },{
    path: '/assess',
    component: Layout,
    redirect: '/assess',
    name: 'assess',
    meta: { title: '拟聘人员考核', icon: 'inhire' },
    children: [
      {
        path: 'assessMain',
        name: 'assessMain',
        component: () => import('@/views/assessment/main/index'),
        meta: { title: '考核管理' },
        hidden: true
      },
      {
        path: 'assessExaminer',
        name: 'assessExaminer',
        component: () => import('@/views/assessment/examiner/index'),
        meta: { title: '考核人导入' },
        hidden: true
      },
    ]
  },{
    path: '/hire',
    component: Layout,
    redirect: '/hire',
    name: 'hire',
    meta: { title: '材料考核', icon: 'hire' },
    children: [
      {
        path: 'index',
        name: 'index',
        component: () => import('@/views/hire/index'),
        meta: { title: '材料考核' },
        hidden: true
      },
      {
        path: 'uploadHire',
        name: 'uploadHire',
        component: () => import('@/views/hire/uploadHire'),
        meta: { title: '材料上传' },
        hidden: true
      },
      {
        path: 'firstHire',
        name: 'firstHire',
        component: () => import('@/views/hire/first'),
        meta: { title: '材料审查' },
        hidden: true
      }
    ]
  },{
    path: '/original',
    component: Layout,
    redirect: '/original',
    name: 'original',
    meta: { title: '原件核准', icon: 'original' },
    children: [
      {
        path: 'index',
        name: 'index',
        component: () => import('@/views/original/index'),
        meta: { title: '原件核准' },
        hidden: true
      },
      {
        path: 'firstOriginal',
        name: 'firstOriginal',
        component: () => import('@/views/original/update'),
        meta: { title: '原件核准' },
        hidden: true
      },
      {
        path: 'viewOriginal',
        name: 'viewOriginal',
        component: () => import('@/views/original/view'),
        meta: { title: '原件核准查看' },
        hidden: true,
      }
    ]
  },{
    path: '/wxNotice',
    component: Layout,
    redirect: '/wxNotice',
    name: 'wxNotice',
    meta: { title: '招聘变更通知', icon: 'wxNotice' },
    children: [
      {
        path: 'index',
        name: 'wxnoticeindex',
        component: () => import('@/views/wxnotice/index_new'),
        meta: { title: '发送通知' },
        hidden: true
      }
    ]
  }, {
    path: '/totalyear',
    component: Layout,
    redirect: '/totalyear',
    name: 'totalyear',
    meta: { title: '招聘数据分析', icon: 'total-week' },
    children: [
      {
        path: 'total',
        name: 'total',
        component: () => import('@/views/totalyear/total'),
        meta: { title: '总体情况', icon: 'total-week' }
      },
      {
        path: 'total_positions',
        name: 'total_positions',
        component: () => import('@/views/totalyear/positions'),
        meta: { title: '岗位分析', icon: 'total-week' }
      },
      {
        path: 'total_user',
        name: 'total_user',
        component: () => import('@/views/totalyear/user'),
        meta: { title: '考生分析', icon: 'total-week' }
      },
      {
        path: 'totalhire',
        name: 'totalhire',
        component: () => import('@/views/totalyear/hire'),
        meta: { title: '录用情况分析', icon: 'total-week' }
      },
      {
        path: 'totalindex',
        name: 'totalindex',
        component: () => import('@/views/totalyear/index'),
        meta: { title: '招聘计划分析', icon: 'total-week' }
      },
      {
        path: 'planpostotal',
        name: 'planpostotal',
        component: () => import('@/views/totalyear/posdata'),
        meta: { title: '各招聘岗位分析', icon: 'total-week' }
      },
      {
        path: 'totalxl',
        name: 'totalxl',
        component: () => import('@/views/totalyear/totalxl'),
        meta: { title: '按学历统计', icon: 'total-week' },
        hidden: true
      },
      {
        path: 'totalxw',
        name: 'totalxw',
        component: () => import('@/views/totalyear/totalxw'),
        meta: { title: '按学位统计', icon: 'total-week' },
        hidden: true
      },
      {
        path: 'totalzc',
        name: 'totalzc',
        component: () => import('@/views/totalyear/totalzc'),
        meta: { title: '按职称等级统计', icon: 'total-week' },
        hidden: true
      },
      {
        path: 'totaltime',
        name: 'totaltime',
        component: () => import('@/views/totalyear/totaltime'),
        meta: { title: '按投递时间段统计', icon: 'total-week' },
        hidden: true
      },
    ]
  },
  {
    path: '/employment_index',
    component: Layout,
    redirect: '/employment_index',
    name: 'employment_index',
    meta: { title: '招聘岗位收集', icon: 'ums-resource' },
    alwaysShow:true,
    children:[
      {
        path: 'employment_plan_index',
        name: 'employment_plan_index',
        alwaysShow:true,
        component: () => import('@/views/employment/index'),
        meta: { title: '岗位收集|上报|审核', icon: 'ums-resource' },
      },
      {
        path: 'employment_examine',
        name: 'employment_examine',
        component: () => import('@/views/employment/examine'),
        meta: { title: '用人审核', icon: 'ums-resource' }
      },
      {
        path: 'employment_positions',
        name: 'employment_positions',
        component: () => import('@/views/employment/positions'),
        meta: { title: '用人需求' },
        hidden: true
      },
    ]
  },
  {
    path: '/employment',
    component: Layout,
    redirect: '/employment',
    name: 'employment',
    meta: { title: '招聘计划管理', icon: 'ums-resource' },
    children: [
      {
        path: 'recruitment_index',
        name: 'recruitment_index',
        component: () => import('@/views/recruitment/index'),
        meta: { title: '招聘计划申报', icon: 'ums-resource'  }
      },
      {
        path: 'recruitment_examine',
        name: 'recruitment_examine',
        component: () => import('@/views/recruitment/examine'),
        meta: { title: '招聘计划审核', icon: 'ums-resource'  }
      },
    ]
  }, {
    path: '/positions_employer',
    component: Layout,
    redirect: '/positions_employer',
    name: 'positions_employer',
    meta: { title: '管理用人计划', icon: 'ums-resource' },
    children: [
      {
        path: 'positions_employer',
        name: 'positions_employer',
        component: () => import('@/views/user/positions/index'),
        meta: { title: '用人计划管理', icon: 'ums-resource' }
      },
      {
        path: 'positions_employer_update',
        name: 'positions_employer_update',
        component: () => import('@/views/user/positions/update'),
        meta: { title: '编辑用人计划岗位' },
        hidden: true
      },
      {
        path: 'positions_employer_view',
        name: 'positions_employer_view',
        component: () => import('@/views/user/positions/view'),
        meta: { title: '查看用人计划岗位' },
        hidden: true
      },
    ]
  },{
    path: '/blacklist',
    component: Layout,
    redirect: '/blacklist',
    name: 'blacklist',
    meta: { title: '黑名单管理', icon: 'ums-resource' },
    children: [
      {
        path: 'blacklist',
        name: 'blacklist',
        component: () => import('@/views/blacklist/index'),
        meta: { title: '黑名单列表', icon: 'ums-resource' }
      },
      {
        path: 'blacklist_update',
        name: 'blacklist_update',
        component: () => import('@/views/blacklist/index'),
        meta: { title: '编辑黑名单' },
        hidden: true
      }
    ]
  }, {
    path: '/department',
    component: Layout,
    redirect: '/user/department',
    name: 'department',
    meta: { title: '设置组织结构', icon: 'product-list' },
    children: [
      // {
      //   path: 'department',
      //   name: 'department',
      //   component: () => import('@/views/user/department/index'),
      //   meta: { title: '设置组织结构', icon: 'ums-resource' }
      // },
      {
        path: 'departmentNew',
        name: 'departmentNew',
        component: () => import('@/views/user/department/department'),
        meta: { title: '组织结构管理', icon: 'ums-resource' }
      },
      {
        path: 'workers',
        name: 'workers',
        component: () => import('@/views/user/department/workers'),
        meta: { title: '职工账号管理', icon: 'ums-resource' }
      },

    ]
  }, {
    path: '/users',
    component: Layout,
    redirect: '/user/users',
    name: 'users',
    meta: { title: '管理应聘者帐号', icon: 'user' },
    children: [
      {
        path: 'user',
        name: 'user',
        component: () => import('@/views/user/users/index'),
        meta: { title: '管理应聘者帐号', icon: 'ums-resource' }
      },
      {
        path: 'personal',
        name: 'personal',
        component: () => import('@/views/user/users/personal'),
        meta: { title: '个人信息', icon: 'ums-role' },
        hidden: true
      }
    ]
  }, {
    path: '/talentpool',
    component: Layout,
    redirect: '/talentpool/index',
    name: 'talentpool',
    meta: { title: '人才库', icon: 'product-list' },
    children: [
      {
        path: 'talenttype',
        name: 'talenttype',
        component: () => import('@/views/talentpool/talenttype'),
        meta: { title: '人才类型', icon: 'ums-resource' }
      },
      {
        path: 'talentindex',
        name: 'talentindex',
        component: () => import('@/views/talentpool/index'),
        meta: { title: '人才查询', icon: 'ums-resource' }
      },
      {
        path: 'talentadd',
        name: 'talentadd',
        component: () => import('@/views/talentpool/add'),
        meta: { title: '编辑人才信息', icon: 'ums-resource' },
        hidden: true
      },
      {
        path: 'talentview',
        name: 'talentview',
        component: () => import('@/views/talentpool/view'),
        meta: { title: '预览人才信息', icon: 'ums-resource' },
        hidden: true
      },
      {
        path: 'talentnotice',
        name: 'talentnotice',
        component: () => import('@/views/talentpool/notice'),
        meta: { title: '招聘推送', icon: 'ums-resource' }
      },

    ]
  },{
    path: '/ums',
    component: Layout,
    redirect: '/ums/admin',
    name: 'ums',
    meta: { title: '系统管理', icon: 'ums' },
    children: [
      {
        path: 'guestbook',
        name: 'guestbook',
        component: () => import('@/views/ums/guestbook/index'),
        meta: { title: '用户意见管理', icon: 'ums-role' }
      },
      {
        path: 'admin',
        name: 'admin',
        component: () => import('@/views/ums/admin/index'),
        meta: { title: '用户列表', icon: 'ums-admin' }
      },
      {
        path: 'role',
        name: 'role',
        component: () => import('@/views/ums/role/index'),
        meta: { title: '角色列表', icon: 'ums-role' }
      },
      {
        path: 'allocMenu',
        name: 'allocMenu',
        component: () => import('@/views/ums/role/allocMenu'),
        meta: { title: '分配菜单' },
        hidden: true
      },
      {
        path: 'menu',
        name: 'menu',
        component: () => import('@/views/ums/menu/index'),
        meta: { title: '菜单列表', icon: 'ums-menu' }
      },
      {
        path: 'addMenu',
        name: 'addMenu',
        component: () => import('@/views/ums/menu/add'),
        meta: { title: '添加菜单' },
        hidden: true
      },
      {
        path: 'updateMenu',
        name: 'updateMenu',
        component: () => import('@/views/ums/menu/update'),
        meta: { title: '修改菜单' },
        hidden: true
      },
      {
        path: 'values',
        name: 'values',
        component: () => import('@/views/ums/values/index'),
        meta: { title: '数据字典', icon: 'values' }
      },
      {
        path: 'employer',
        name: 'employer',
        component: () => import('@/views/ums/employer/index'),
        meta: { title: '用人单位管理', icon: 'employer' }
      },
      {
        path: 'help',
        name: 'help',
        component: () => import('@/views/ums/help/index'),
        meta: { title: '帮助中心', icon: 'help' }
      },
      {
        path: 'addHelp',
          name: 'addHelp',
        component: () => import('@/views/ums/help/add'),
        meta: {title: '添加帮助'},
        hidden: true
      },
      {
        path: 'updateHelp',
          name: 'updateHelp',
        component: () => import('@/views/ums/help/update'),
        meta: {title: '编辑帮助'},
        hidden: true
      }
    ]
  },
  { path: '*', redirect: '/404', hidden: true }
]

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})



// WEBPACK FOOTER //
// ./src/router/index.js